export const userSignupAPI =
  "https://catalogmaker.in/catalogMakerApi/public/api/";
